import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PrincipalConfigurationService } from '../../../../core/user';

@Component({
  selector: 'py-service-unavailable-alert',
  templateUrl: './service-unavailable-alert.component.html',
  styleUrls: ['./service-unavailable-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceUnavailableAlertComponent implements OnInit {
  isServiceUnavailable$: Observable<boolean>;

  constructor(private principalConfigurationService: PrincipalConfigurationService) {}

  ngOnInit(): void {
    this.isServiceUnavailable$ = this.principalConfigurationService
      .isEnabled('enableSapOnlineFunctions')
      .pipe(map((isSapOnlineFunctionsEnabled) => !isSapOnlineFunctionsEnabled));
  }
}
